module.exports = __webpack_public_path__ + "img/card_crew.a1d600c2.jpg";